import $ from 'jquery';
import 'slick-carousel';

const Carousels = {

	/**
	 * Carousels.
	 *
	 * @type {object}
	 */
	els: [],

	/**
	 * Default setup.
	 *
	 * @type {object}
	 */
	defaults: {
		autoplay: false,
		autoplaySpeed: 4000
	},

	/**
	 * Initialize.
	 *
	 * @returns {void}
	 */
	init() {
		this.initDefault();
	},

	/**
	 * Initalize default carousel.
	 *
	 * @returns {void}
	 */
	initDefault() {
		let self = this;
		self.els = $( '[data-carousel="default"]' );

		$.each( self.els, function( i, carousel ) {
			const $carousel = $( carousel );

			$carousel.find( '[data-carousel-slides]' ).slick( Object.assign({}, self.defaults, {
				prevArrow: $carousel.find( '[data-carousel-arrow="prev"]' ),
				nextArrow: $carousel.find( '[data-carousel-arrow="next"]' )
			}) );

			$carousel.addClass( 'is-active' );
		});
	}
};

export default Carousels;

